<app-ranged-result-chart #chart></app-ranged-result-chart>

<app-result-table
  #resultTable
  [solverResultsAndConditonsAndRangeVariable]="solverResultsAndConditonsAndRangeVariable"
  [showComplex]="true"
  (selection)="selection($event)"
  (pinnedSelection)="pinSelection($event)"
  (clearedSelection)="clearPinnedSelection()"
  >

</app-result-table>